import { useContext } from 'react';
import { FC, ReactNode } from 'react';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import useAuth from '../hooks/useAuth';
import UserContext from 'src/contexts/UserContext';
import { emailVerifiedRedirect } from './emailVerifiedRedirect';

interface AuthGuardProps {
  children?: ReactNode;
}

const AuthGuard: FC<AuthGuardProps> = ({ children }) => {
  const { isAuthenticated, user } = useAuth();
  const userContext = useContext(UserContext).userData;

  if (!isAuthenticated) {
    return <Redirect to="/login" />;
  }

  const verifyRedirect = emailVerifiedRedirect(user);
  if (verifyRedirect) {
    return verifyRedirect;
  }

  if (userContext.signupCompleted === true) {
    return <Redirect to="/app" />;
  }

  return <>{children}</>;
};

AuthGuard.propTypes = {
  children: PropTypes.node,
};

export default AuthGuard;
